import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { color } from '../styles/helpers/variables';

const RadioButton = props => (
  <RadioButtonContainer>
    <InputRadioButton
      id={props.id}
      theme={props.theme}
      name={props.name}
      defaultChecked={props.defaultChecked}
      value={props.value}
      onChange={props.onChange}
      checked={props.checked}
    />
    <InputLabel htmlFor={props.id}>{props.children}</InputLabel>
  </RadioButtonContainer>
);

RadioButton.defaultProps = {
  defaultChecked: false,
  onChange: () => {},
  value: null,
  theme: null,
  checked: false,
};

RadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  defaultChecked: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  theme: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  checked: PropTypes.bool,
};

export default RadioButton;

const RadioButtonContainer = styled.div`
  margin: 10px 0;
`;

export const InputLabel = styled.label`
  width: 100%;
  display: flex;
  cursor: pointer;
  position: relative;
`;

export const InputRadioButton = styled.input.attrs({
  type: 'radio'
})`
  &:checked,
  &:not(:checked) {
    position: absolute;
    left: -9999px;
  }
  &:checked + label,
  &:not(:checked) + label {
    position: relative;
    padding-left: 16px;
    cursor: pointer;
  }
  &:checked + label:before,
  &:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 1px solid ${color.grey};
    border-radius: 100%;
    background-color: ${props => (props.theme === 'white' ? color.white : color.lightGrey)};
  }
  &:checked + label:after,
  &:not(:checked) + label:after {
    content: '';
    width: 10px;
    height: 10px;
    background-color: ${color.primary};
    position: absolute;
    top: 5px;
    left: 5px;
    border-radius: 100%;
    transition: transform 250ms ease-out, opacity 500ms ease-out;
  }
  &:not(:checked) + label:after {
    opacity: 0;
    transform: scale(0);
  }
  &:checked + label:after {
    opacity: 1;
    transform: scale(1);
  }
`;



// WEBPACK FOOTER //
// ./src/components/RadioButton.js